import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionService } from '../session/session.service';
import { Language } from '../interfaces/language.interface';

@Component({
    selector: 'ngbd-switch-language-modal',
    template: `
    <div class="modal-header">
      <div class="modal-title"><fa-icon [icon]="['fas', 'globe']" [fixedWidth]="true" class="me-2"></fa-icon>{{ 'label.byt-sprak' | translate }}</div>
      <button type="button" class="btn-close" [title]="'button.stang' | translate" [attr.aria-label]="'button.stang' | translate" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="flag-container">
        @for (language of languages | orderBy: 'index'; track language) {
          <div class="flag-item">
            <button class="btn btn-outline-primary" (click)="switchLanguage(language.id)" [class.active]="currentLanguage===language.id" [attr.aria-pressed]="currentLanguage===language.id" [attr.title]="'language.' + language.name | translate">
              <span class="flag-icon-background d-block h-100 rounded border border-dark" [ngClass]="'flag-icon-' + language.flag"></span>
            </button>
            <span class="flag-label" [class.active]="currentLanguage===language.id">{{ 'language.' + language.name | translate }}</span>
          </div>
        }
      </div>
    </div>`,
    styles: [`
    .btn {
      padding: .375rem;
      width: 100%;
      height: 100%;
      border-radius: .5rem;
    }

    .btn:not(:focus) {
      border-color: transparent;
    }

    .btn:not(.active):not(:active):hover {
      background-color: rgb(0 123 255 / 50%);
    }

    .btn:hover {
      box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 50%);
    }

    .flag-container {
      padding: 0 0 1.2rem 0;
      margin: 0;
      list-style: none;
      -webkit-flex-flow: row;
      column-gap: 1rem;
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-flow: column;
    }

    .flag-icon-background {
      background-size: cover;
    }

    .flag-item {
      flex: 1 0 auto;
    }

    .flag-item:before {
      content: '';
      float: left;
      padding-top: 75%;
    }

    .flag-label {
      text-transform: uppercase;
      text-align: center;
      display: block;
      font-size: .8rem;
    }

    .flag-label.active {
      color: #007bff;
    }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdSwitchLanguageModal {
  constructor(
    public activeModal: NgbActiveModal,
    protected translate: TranslateService,
    protected spinner: NgxSpinnerService,
    protected session: SessionService,
    @Inject('LANGUAGES') public languages: Language[]) {
  }

  public switchLanguage(language: string) {
    this.spinner.show();
    this.translate.use(language).subscribe(() => {
      this.session.setLanguage(language);
      this.spinner.hide();
    });
    this.close();
  }

  public get currentLanguage() {
    return this.translate.getCurrentLang() || this.translate.getFallbackLang();
  }

  public close() {
    this.activeModal.close();
  }
}
